import styled, { css } from 'styled-components';
import { getTextType, backgroundShape } from '../../../stylesheets/tools';

const StyledNotification = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  ${backgroundShape()}
  width: 300px;
  color: #fff;
  padding: 20px;
  z-index: 9999;

  p, span {
    ${getTextType('copySmall', 'international')}
    font-weight: 700;
  }

  ${props =>
    props.type === 'error' &&
    css`
      ${backgroundShape('red')}
    `}

  ${props =>
    props.type === 'warning' &&
    css`
      ${backgroundShape('gold')}
      color: #000;
    `}

  ${props =>
    props.type === 'success' &&
    css`
      ${backgroundShape('green')}
    `}
`;

export default StyledNotification;
